export default {
  id: 80,
  title: 'Target #80 - Piano',
  url: 'https://cssbattle.dev/play/80',
  colors: ['#998235', '#191919', '#FFFFFF'],
  solution:
    '<a a><a b><a c><style>[b],[c]{top:125}[a],[c]{background:#191919}body{background:#998235}a{position:fixed}[a]{top:100;left:110;width:180;height:100;border-radius:10px}[b]{left:115;width:20;height:70;background:#fff;border-radius:5px;box-shadow:25px 0 #fff,50px 0 #fff,75px 0 #fff,100px 0 #fff,125px 0 #fff,150px 0 #fff}[c]{left:130;width:15;height:35;box-shadow:25px 0 #191919,75px 0 #191919,100px 0 #191919,125px 0 #191919}</style>',
}
